import React, { useEffect, useState, useCallback } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const NebulaBackground = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => setInit(true));
  }, []);

  const particlesLoaded = useCallback(async () => {}, []);

  return (
    init && (
      <Particles
        id="tsparticles"
        particlesLoaded={particlesLoaded}
        options={{
          fullScreen: { enable: true, zIndex: -1 },
          background: {
            color: { value: "#0b0019" },
          },
          particles: {
            number: { value: 100, density: { enable: true, area: 800 } },
            color: { value: ["#5f0aff", "#8b5cf6", "#00e1ff"] },
            move: {
              enable: true,
              speed: 0.8,
              direction: "none",
              random: true,
              outModes: "out",
              trail: {
                enable: true,
                length: 4,
                fill: { color: "#0b0019" },
              },
            },
            size: { value: { min: 1, max: 3 } },
            opacity: { value: 0.5 },
            links: {
              enable: true,
              distance: 120,
              color: "#6d28d9",
              opacity: 0.3,
              width: 1,
            },
          },
          interactivity: {
            events: {
              onHover: { enable: true, mode: "repulse" },
              onClick: { enable: true, mode: "push" },
            },
            modes: {
              repulse: { distance: 150, duration: 0.4 },
              push: { quantity: 4 },
            },
          },
        }}
      />
    )
  );
};

export default NebulaBackground;
